module.exports = __webpack_public_path__ + "static/media/backpack.4818ec31.svg";